/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_NumberInputs */



/**
* | output |
* | --- |
* | "NUMBER" |
*
* @param {Ccsl_Export_Header_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_number = /** @type {((inputs?: Ccsl_Export_Header_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("NUMERO")
	if (locale === "de") return /** @type {LocalizedString} */ ("NUMMER")
	if (locale === "it") return /** @type {LocalizedString} */ ("NUMERO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ЧИСЛО")
	if (locale === "es") return /** @type {LocalizedString} */ ("NÚMERO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("数字")
	if (locale === "ja") return /** @type {LocalizedString} */ ("番号")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("NÚMERO")
	return /** @type {LocalizedString} */ ("NUMBER")
});